import { createAsyncThunk } from '@reduxjs/toolkit';
import { $apiV1 } from '../../config/api';

export const getStatistics = createAsyncThunk(
  'statistics/get_statistics',
  async ({
    id,
    page = 1,
    year_season_id,
  }, { rejectWithValue }) => {
    try {
      const response = await $apiV1.get(year_season_id ? `/statistics/season_opt/${id}?page=${page}&year_season_id=${year_season_id}` : `/statistics/season_opt/${id}?page=${page}`);
      return response.data;
    } catch (e) {
      return rejectWithValue(`${e.response.data.message}`);
    }
  },
);

export const getStatisticsPaginate = createAsyncThunk(
  'statistics/get_statistics_paginate',
  async ({
    id,
    page = 1,
    year_season_id,
  }, { rejectWithValue }) => {
    try {
      const response = await $apiV1.get(year_season_id ? `/statistics/season_opt/${id}?page=${page}&year_season_id=${year_season_id}` : `/statistics/season_opt/${id}?page=${page}`);
      return response.data;
    } catch (e) {
      return rejectWithValue(`${e.response.data.message}`);
    }
  },
);

export const getTournamentStat = createAsyncThunk(
  'statistics/get_tournament',
  async ({ id, stage }, { rejectWithValue }) => {
    try {
      const response = await $apiV1.get(`/statistics/season_opt/${id}?stage=${stage}`);
      return response.data;
    } catch (e) {
      return rejectWithValue(`${e.response.data.message}`);
    }
  },
);
